<template>
    <p class="_e-FormTextDisabled" v-if="disabled">Veuillez remplir les étapes précèdentes</p>
</template>
<script>
  export default {
    name: 'FormTextDisabled',
    props: {
      disabled: {type: Boolean, default: true},
    },
  };
</script>
<style scoped>
    ._e-FormTextDisabled {
        opacity: 0.7;
        color: #ff5356;
        padding-left: 15px;
        margin: 0;
        margin-left: 3rem;
        border-left: 2px solid #ff5356;
    }
</style>